var map = {
	"./additionalInfoIcon.svg": 518,
	"./arrowLeftIcon.svg": 519,
	"./arrowMediumTop.svg": 520,
	"./arrowRightIcon.svg": 521,
	"./arrowRightIconSharp.svg": 522,
	"./arrowRightSmallIcon.svg": 523,
	"./arrowScalableIcon.svg": 524,
	"./arrowSelect2.svg": 525,
	"./arrowSelectIcon.svg": 526,
	"./benefit1.svg": 527,
	"./benefit2.svg": 528,
	"./benefit3.svg": 529,
	"./cardsIcon.svg": 530,
	"./copyIcon copy.svg": 531,
	"./copyIcon.svg": 532,
	"./crossIcon.svg": 533,
	"./crossIcon2.svg": 534,
	"./crossIcon3.svg": 535,
	"./crossIconSmall.svg": 536,
	"./crossSmallIcon.svg": 537,
	"./defaultCategoryIcon.svg": 538,
	"./depNumberIcon.svg": 539,
	"./elfCentralIcon.svg": 540,
	"./equalitySign.svg": 541,
	"./errorIcon.svg": 429,
	"./eyeClosedIcon.svg": 542,
	"./eyeOpenIcon.svg": 543,
	"./favoritesIcon.svg": 544,
	"./favoritesLabelIcon.svg": 545,
	"./filterDivider.svg": 546,
	"./filterIcon.svg": 547,
	"./frequencyIcon.svg": 548,
	"./fsAmountIcon.svg": 549,
	"./fullScreenIcon.svg": 550,
	"./gameIcon.svg": 551,
	"./hamburgerIcon.svg": 552,
	"./infoIcon.svg": 553,
	"./infoSymbol.svg": 554,
	"./levelBackground.svg": 555,
	"./levelBackgroundNew.svg": 556,
	"./linkIcon.svg": 557,
	"./lockIcon.svg": 558,
	"./lockSharpIcon.svg": 559,
	"./maxBonusAmountIcon.svg": 560,
	"./maxWinFsIcon.svg": 561,
	"./menuIcon.svg": 562,
	"./minDepIcon.svg": 563,
	"./noTournamentIcon.svg": 564,
	"./playIcon.svg": 565,
	"./polygon.svg": 566,
	"./preloaderDotsAnimation.svg": 567,
	"./preloaderSpinnerAnimation.svg": 568,
	"./presentIcon.svg": 569,
	"./promoIcon.svg": 570,
	"./recentIcon.svg": 571,
	"./search2Icon.svg": 572,
	"./search3Icon.svg": 573,
	"./sharpTickIcon copy.svg": 574,
	"./sharpTickIcon.svg": 575,
	"./smallInfoSymbol.svg": 576,
	"./smoothArrowIcon.svg": 577,
	"./successIcon.svg": 578,
	"./supportIcon.svg": 579,
	"./tag1Icon.svg": 580,
	"./tag2Icon.svg": 581,
	"./tag3Icon.svg": 582,
	"./tag4Icon.svg": 583,
	"./tickIcon.svg": 584,
	"./unverified.svg": 585,
	"./verified.svg": 586,
	"./wagerIcon.svg": 587,
	"./wagerTimeIcon.svg": 588,
	"./warningIcon.svg": 589
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 517;